import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const from = loc.state?.from?.pathname || "/admin";
    const [email, setEmail] = useState("admin@yacrrd-ss.org");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await login(email, password);
            nav(from, { replace: true });
        } catch (err) {
            const d = err?.response?.data?.detail;
            setError(typeof d === "string" ? d : "Invalid credentials");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex h-14 w-14 items-center justify-center bg-primary text-primary-foreground rounded-sm mb-4">
                        <Lock size={22} />
                    </div>
                    <h1 className="font-display text-3xl mb-1">YACRRD Admin</h1>
                    <p className="text-sm text-muted-foreground">Sign in to manage the website.</p>
                </div>
                <form onSubmit={submit} className="bg-card border border-border rounded-sm p-8 space-y-5" data-testid="admin-login-form">
                    <div>
                        <label className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2 block">Email</label>
                        <input
                            type="email" required value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 rounded-sm border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/40"
                            data-testid="login-email"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2 block">Password</label>
                        <input
                            type="password" required value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 rounded-sm border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/40"
                            data-testid="login-password"
                        />
                    </div>
                    {error && <div className="text-sm text-destructive" data-testid="login-error">{error}</div>}
                    <button
                        type="submit" disabled={submitting}
                        className="w-full py-3 rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 text-sm font-medium disabled:opacity-60"
                        data-testid="login-submit"
                    >
                        {submitting ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}
